module.exports = __webpack_public_path__ + "img/card_reload.35d65f78.png";